// PropTypes
import PropTypes from 'prop-types'

export default function FoulardsFinishForm({ values }) {
  const blockStyle =
    'grid items-center grid-cols-12 p-3 lg:auto-rows-min print:p-1.5 md:gap-y-1 lg:gap-y-3 print:gap-y-1 print:auto-rows-auto'
  const firstLabelStyles =
    'col-span-12 text-sm print:col-span-3 lg:col-span-4 xl:col-span-3 font-ms-semi'
  const otherLabelsStyles =
    'col-span-12 mt-5 text-sm print:col-span-3 lg:mt-5 xl:mt-0 lg:col-span-4 xl:col-span-3 font-ms-semi print:mt-0'
  const firstParentStyles =
    'flex items-center col-span-12 space-x-2 cursor-not-allowed min-h-8 print:h-full print:col-span-9 lg:col-span-8 xl:col-span-9'
  const otherParentStyles =
    'flex items-center col-span-12 mt-0 space-x-2 cursor-not-allowed lg:mt-5 xl:mt-0 print:mt-0 min-h-8 print:h-full print:col-span-9 lg:col-span-8 xl:col-span-9'
  const innerParentStyles =
    'w-full p-0.5 print:p-0 print:h-full leading-tight print:leading-none text-base border-b border-gray-300 overflow-ellipsis overflow-hidden flex items-center place-self-end'
  const checkStyles = 'border border-gray-800 ft-check'

  return (
    <div className={blockStyle}>
      {/* CONTINGUT CUBETA */}
      <div className={firstLabelStyles}>Contingut cubeta:</div>
      <div className={firstParentStyles}>
        <div className={innerParentStyles}>{values?.FoulardName}</div>
        <div className={checkStyles}></div>
      </div>

      {/* FÒRMULA */}
      <div className={otherLabelsStyles}>Fòrmula:</div>
      <div className={otherParentStyles}>
        <div className={innerParentStyles}>{values?.FoulardFormula}</div>
        <div className={checkStyles}></div>
      </div>

      {/* DOSICIFACIÓ */}
      <div className={otherLabelsStyles}>Dosificació:</div>
      <div className={otherParentStyles}>
        <div className={innerParentStyles}>
          {values?.IsDosificated ? 'Sí' : 'No'}
        </div>
      </div>

      {/* Nº RECEPTA */}
      <div className={otherLabelsStyles}>Nº recepta:</div>
      <div className={otherParentStyles}>
        <div className={innerParentStyles}>{values?.FoulardRecipeNumber}</div>
        <div className={checkStyles}></div>
      </div>

      {/* OBSERVACIONS */}
      <div className={otherLabelsStyles}>Observacions:</div>
      <div className={otherParentStyles}>
        <div className={innerParentStyles}>{values?.FoulardObservation}</div>
      </div>
    </div>
  )
}

FoulardsFinishForm.propTypes = {
  values: PropTypes.object
}
